// extracted by mini-css-extract-plugin
export default {"cls1":"fD3bHZRjV_UIaZ77qBog","cls2":"PJKzAgFHI6GYHO05fzOz fD3bHZRjV_UIaZ77qBog"};